export enum WldConsentResponseStatus {
  ACCEPT = 'ACCEPT',
  DECLINE = 'DECLINE',
}

export interface WldDocumentSharingConsent {
  responseStatus: WldConsentResponseStatus;
  lastModifiedDateTime: string;
}
